import React from 'react';
import FormContainer from '../../../Components/Form/FormContainer';
import Text from '../../../Components/Base/Text/Text';
import CheckboxField from '../../../Components/Form/components/CheckboxField';
import FormCondition from '../../../Components/Form/FormCondition';
import { RepeatInterval } from '../Enums/RepeatInterval.enum';

interface Props {
	text: string;
}

const ScheduleInSpecificDaysInWeekFields: React.FC<Props> = ({ text }) => (
	<FormCondition
		controlName='repeatInterval'
		equal={RepeatInterval.SPECIFIC_DAYS_IN_WEEK}>
		<FormContainer name='specificDaysInWeek'>
			<Text tx={text} style={{ fontSize: '14px' }} />
			<div
				className={'d-flex flex-row'}
				style={{
					gap: '23px',
					width: '100%',
					marginBottom: '20px',
					marginTop: '10px',
				}}>
				<CheckboxField name='mon' tx='base.weekDaysShorts.monday' />
				<CheckboxField name='tue' tx='base.weekDaysShorts.tuesday' />
				<CheckboxField name='wed' tx='base.weekDaysShorts.wednesday' />
				<CheckboxField name='thu' tx='base.weekDaysShorts.thursday' />
				<CheckboxField name='fri' tx='base.weekDaysShorts.friday' />
				<CheckboxField name='sat' tx='base.weekDaysShorts.saturday' />
				<CheckboxField name='sun' tx='base.weekDaysShorts.sunday' />
			</div>
		</FormContainer>
	</FormCondition>
);

export default ScheduleInSpecificDaysInWeekFields;
